import {
  AppBar,
  Toolbar,
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  Drawer,
  Collapse,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import logoFull from "../../../images/logoFull.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../app/router/routes";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Zoom from "@mui/material/Zoom";
import { useMobileHeaderSecondaryStyles } from "./mobileHeaderSecondaryStyles";
import { colors } from "../../../app/theme/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTranslation } from "react-i18next";

type Anchor = "left";

interface Props {
  handleSearch?: any;
}

const GradientAppBar = styled(AppBar)(({ theme }) => ({
  backgroundRepeat: "no-repeat",
  backgroundColor: colors.primary,
  backgroundSize: "37%",
}));

const MobileHeaderSecondary = ({ handleSearch }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { classes } = useMobileHeaderSecondaryStyles();
  const [servicesMenuOpen, setServicesMenuOpen] = useState(false);

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open || servicesMenuOpen });
    };

  const handleButtonClick = (route: string) => {
    navigate(route);
  };

  useEffect(() => {
    if (servicesMenuOpen) {
      setState({
        ...state,
        left: true,
      });
    }
  }, [servicesMenuOpen]);

  const list = (anchor: Anchor) => (
    <Grid
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      className={classes.list}
      alignItems="center"
    >
      <Grid container className={classes.iconWrapper}>
        <Zoom in={state.left === true} timeout={500}>
          <CloseIcon
            className={classes.closeIcon}
            onClick={toggleDrawer(anchor, false)}
          />
        </Zoom>
      </Grid>
      <List>
        <ListItem
          button
          id="home-btn"
          onClick={() => handleButtonClick(routes.home)}
        >
          <ListItemText className={classes.listItemText}>
            {t("header.homePage")}
          </ListItemText>
        </ListItem>
        <Divider className={classes.divider} variant="middle" />

        <ListItem
          button
          onClick={() => setServicesMenuOpen(!servicesMenuOpen)}
          className={classes.listItem}
          id="services-btn"
        >
          <ListItemText
            className={classes.listItemTextServices}
            sx={{ marginLeft: "10px" }}
          >
            {t("header.services")}
          </ListItemText>
          {servicesMenuOpen ? (
            <ExpandLessIcon className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )}
        </ListItem>
        <Collapse in={servicesMenuOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              onClick={() => handleButtonClick(routes.updateData)}
              id="update-data-btn"
            >
              <ListItemText className={classes.listItemText}>
                {t("header.updateData")}
              </ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => handleButtonClick(routes.advertisement)}
              id="advertisement-btn"
            >
              <ListItemText className={classes.listItemText}>
                {t("header.advertisement")}
              </ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => handleButtonClick(routes.digitalMarketing)}
              id="digital-marketing-btn"
            >
              <ListItemText className={classes.listItemText}>
                {t("header.digitalMarketing")}
              </ListItemText>
            </ListItem>
          </List>
        </Collapse>
        <Divider className={classes.divider} variant="middle" />

        <ListItem
          button
          onClick={() => handleButtonClick(routes.editions)}
          id="editions-btn"
        >
          <ListItemText className={classes.listItemText}>
            {t("header.editions")}
          </ListItemText>
        </ListItem>
        <Divider className={classes.divider} variant="middle" />

        <ListItem
          button
          onClick={() => handleButtonClick(routes.about)}
          id="about-btn"
        >
          <ListItemText className={classes.listItemText}>
            {t("header.aboutUs")}
          </ListItemText>
        </ListItem>
        <Divider className={classes.divider} variant="middle" />
        <ListItem
          button
          onClick={() => handleButtonClick(routes.contact)}
          id="contact-btn"
        >
          <ListItemText className={classes.listItemText}>
            {t("header.contact")}
          </ListItemText>
        </ListItem>
      </List>
    </Grid>
  );

  return (
    <GradientAppBar position="static">
      <Toolbar>
        <Grid container>
          <Grid item xs={6} justifyContent="flex-start">
            {(["left"] as Anchor[]).map((anchor) => (
              <React.Fragment key={anchor}>
                <MenuIcon
                  id="header-menu-icon"
                  style={{ marginTop: "12px" }}
                  onClick={toggleDrawer(anchor, true)}
                />
                <Drawer
                  id="header-drawer"
                  style={{ opacity: 0.9 }}
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  {list(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </Grid>
          <Grid item xs={6} className={classes.logoWrapper}>
            <img id="header-logo" src={logoFull} className={classes.logoFull} onClick={() => handleButtonClick(routes.home)}/>
          </Grid>
        </Grid>
      </Toolbar>
    </GradientAppBar>
  );
};

export default MobileHeaderSecondary;
